import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section className="services-section">
      <div className="content">
        <h2>Our Services</h2>
        <p>Explore our range of services including cloud computing, cybersecurity, software engineering, and more.</p>
      </div>
    </section>
  );
};

export default Services;
